var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoldCollapsechevron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "23px",
    viewBox: "0 0 42 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "COLLAPSE CHEVRON") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-March-2025",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "09-BOOKINGv2-3---Selected",
    transform: "translate(-821, -3975)",
    fill: "#010421",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotel-details-card",
    transform: "translate(10, 1787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "amenities-accordion",
    transform: "translate(16, 1581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "view-all",
    transform: "translate(396, 596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.340397,33.3246564 C419.254365,34.2251145 420.732271,34.2251145 421.636516,33.3246564 L440.314524,14.9323199 C441.228492,14.0318617 441.228492,12.5758017 440.314524,11.6849229 C439.400556,10.7940441 437.92265,10.7844648 437.018405,11.6849229 L420.003041,28.4487713 L402.977954,11.6753436 C402.063986,10.7748855 400.58608,10.7748855 399.681835,11.6753436 C398.77759,12.5758017 398.767867,14.0318617 399.681835,14.9227405 L418.340397,33.3246564 Z",
    id: "COLLAPSE-CHEVRON"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldCollapsechevron);
export default __webpack_public_path__ + "static/media/BoldCOLLAPSE CHEVRON.c10be954d99b3d66d010020aa66110d8.svg";
export { ForwardRef as ReactComponent };